import {DOUBLE_END_MONITOR} from '@/enmus/PageNames';
export default {
    component: () => import('@/views/dataReport/jsDataMonitor/doubleEndMonitor/index.vue'),
    path: 'doubleEndMonitor',
    name: DOUBLE_END_MONITOR,
    meta: {
        name: DOUBLE_END_MONITOR,
        title: '双端日志'
    }
};
